import { ref, watch } from "vue"
import FuncoesHelper from "@/helpers/FuncoesHelper"

class ComponenteEtapaService {
    setup({ dadosComponentes }) {
        const identificador = ref(FuncoesHelper.obterParametrosRota('identificador'))
        const etapaAtual = ref(FuncoesHelper.obterParametrosRota('etapa'))
        const localRealizacao =  ref(FuncoesHelper.obterParametrosRota('localRealizacao'))
        const modulo =  ref(FuncoesHelper.obterParametrosRota('modulo'))
        const componentesEtapa = ref(dadosComponentes)

        watch(() => FuncoesHelper.obterParametrosRota('etapa'), (etapa) => {
            etapaAtual.value = etapa
            this.manipulaScrollEtapa()
        })

        return {
            identificador,
            componentesEtapa,
            localRealizacao,
            modulo,
            etapaAtual,
        };
    }

    manipulaScrollEtapa() {
        setTimeout(() => {
            document.querySelectorAll('[data-href^="#"]').forEach(anchor => {
                anchor.addEventListener('click', function () {
                    const targetId = this.getAttribute('data-href').substring(1);
                    const targetElement = document.getElementById(targetId);
                    if (targetElement) {
                        const container = document.querySelector('.flex-container');
                        const targetPosition = targetElement.offsetLeft;
                        const containerWidth = container.clientWidth;
                        const targetWidth = targetElement.clientWidth;
                        const scrollPosition = targetPosition - (containerWidth / 2) + (targetWidth / 2) - 100;

                        container.scrollTo({
                            left: scrollPosition,
                            behavior: 'smooth',
                        });
                    }
                });

                if (anchor.getAttribute('data-selecionado') === 'true') {
                    anchor.scrollIntoView({ behavior: 'smooth', block: 'center' });
                }
            });
        }, 200);
    }
}

export default new ComponenteEtapaService();